<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <h1>Company reporting</h1>

        <div class="d-flex justify-center flex-wrap mt-4">
          <v-chip to="/reporting/billing/dashboard" class="mr-2" outlined pill medium active-class="active-chip"
            >Active Subscriptions</v-chip
          >
          <v-chip
            v-if="superUser"
            to="/reporting/billing/payment-issues"
            class="mr-2"
            outlined
            pill
            medium
            active-class="active-chip"
          >
            Recon
          </v-chip>
          <v-chip
            to="/reporting/billing/cancellation-requests"
            class="mr-2"
            outlined
            pill
            medium
            active-class="active-chip"
            >Cancellation Requests
          </v-chip>
          <v-chip to="/reporting/billing/cancellations" class="mr-2" outlined pill medium active-class="active-chip"
            >Cancellations
          </v-chip>
          <v-chip to="/reporting/billing/sign-ups" class="mr-2" outlined pill medium active-class="active-chip"
            >Sign-ups
          </v-chip>
          <v-chip to="/reporting/billing/sales" class="mr-2" outlined pill medium active-class="active-chip">
            Cash flow
          </v-chip>
          <v-chip to="/reporting/billing/prize-report" class="mr-2" outlined pill medium active-class="active-chip">
            Prize Report
          </v-chip>
          <v-chip to="/reporting/billing/failed-payments" class="mr-2" outlined pill medium active-class="active-chip">
            Failed Payments
          </v-chip>
          <v-chip
            to="/reporting/billing/cashflow-projection"
            class="mr-2"
            outlined
            pill
            medium
            active-class="active-chip"
          >
            Projections
          </v-chip>
        </div>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="4">
        <v-menu
          ref="menu1"
          v-model="menu1"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="Start Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="startDate"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="4">
        <v-menu
          ref="menu2"
          v-model="menu2"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="End Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="endDate"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <router-view :startDate="startDate" :endDate="endDate"></router-view>
  </v-container>
</template>

<script>
export default {
  name: "ReportingBase",

  data() {
    return {
      startDate: null,
      endDate: null,
      menu1: false,
      menu2: false,
    };
  },
  computed: {
    superUser() {
      return this.$store.getters.user.isSuperuser;
    },
  },
};
</script>

<style scoped>
.active-chip {
  color: var(--v-light-purple-base);
  border: 2px solid var(--v-green-base);
  font-weight: 600;
}
</style>
